import { $ as e, C as t, F as n, L as r, M as i, S as a, U as o, _ as s, g as c, h as l, i as u, it as d, k as f, m as p, ot as m, p as h, rt as g, t as _, v, w as y } from "./_plugin-vue_export-helper-CTQVpqU-.js";
import { n as b, r as x, t as S } from "./normalize-props-DNjMoRjC.js";
import { t as C } from "./Loading.ce-Babnon5y.js";
//#region src/webcomponents/message-conversation/Message.ce.vue?vue&type=script&setup=true&lang.ts
var w = ["part"], T = {
	key: 1,
	class: "message__loader message__content",
	"aria-hidden": "true"
}, E = ["part"], D = { key: 1 }, O = { key: 0 }, k = /*#__PURE__*/ _(/* @__PURE__ */ y({
	__name: "Message.ce",
	props: {
		displaySender: {
			type: Boolean,
			default: !0
		},
		message: { type: Object },
		startAnimation: { type: Number },
		animationDuration: { type: Number },
		loadingDuration: { type: Number }
	},
	setup(o, { expose: c }) {
		let u = e("hidden"), _ = e([]), y = p(() => o.message.content?.split("\n"));
		function b(e) {
			return new Promise((t) => {
				let n = setTimeout(t, e);
				_.value.push(n);
			});
		}
		async function x() {
			await b(o.startAnimation), u.value = "loading", await b(o.loadingDuration), u.value = "visible", await b(o.animationDuration);
		}
		i(x);
		async function S() {
			u.value = "hidden", _.value.forEach(clearTimeout), await x();
		}
		return c({ reset: S }), (e, i) => (n(), v("div", { class: g(["message", [`message--${o.message.direction}`, { "hidden-state": u.value === "hidden" }]]) }, [
			o.displaySender ? (n(), v("p", {
				key: 0,
				class: "message__sender",
				part: `sender ${o.message.direction}`
			}, [i[0] ||= l("span", { class: "sr-only" }, "Message de ", -1), a(m(o.message.userName), 1)], 8, w)) : s("", !0),
			u.value === "loading" ? (n(), v("div", T, [t(C)])) : s("", !0),
			l("p", {
				class: g(["message__content", { "hidden-state": u.value !== "visible" }]),
				part: `message ${o.message.direction}`
			}, [
				o.message.image ? (n(), v("img", d(f({ key: 0 }, o.message.image)), null, 16)) : s("", !0),
				o.message.image && y.value ? (n(), v("br", D)) : s("", !0),
				(n(!0), v(h, null, r(y.value, (e, t) => (n(), v(h, { key: t }, [t > 0 ? (n(), v("br", O)) : s("", !0), a(" " + m(e), 1)], 64))), 128))
			], 10, E)
		], 2));
	}
}), [["styles", [".message{max-width:80%;position:relative}.message--incoming{align-self:start}.message--incoming .message__sender{padding-left:10px}.message--incoming .message__loader{left:10px}.message--incoming .message__content{background-color:#e8e8e8}.message--outgoing{align-self:end}.message--outgoing .message__sender{text-align:right;padding-right:10px}.message--outgoing .message__loader{right:10px}.message--outgoing .message__content{background-color:#d1eaff}.message__sender{color:#444;margin:0;font-size:.8rem;font-weight:700}.message__loader{width:24px;position:absolute}.message__content{border-radius:16px;margin:0;padding:10px 14px}.message__content:not(.hidden-state){animation:.3s ease-in-out both fade}.message__content>img{max-width:100%}.hidden-state{visibility:hidden}@keyframes fade{0%{opacity:0}to{opacity:1}}@media (prefers-reduced-motion:reduce){.message__content:not(.hidden-state){animation:none}.message__loader{display:none}.hidden-state{visibility:visible}}"]]]), A = { part: "conversation" }, j = { class: "sr-only" }, M = u(/* @__PURE__ */ _(/* @__PURE__ */ y({
	__name: "MessageConversation.ce",
	props: {
		conversationTitle: {
			default: "Conversation par messages",
			type: String
		},
		messages: { type: Array },
		animationSpeed: {
			default: 20,
			type: Number
		}
	},
	setup(e, { expose: t }) {
		let i = 50 * e.animationSpeed, a = 50 * e.animationSpeed, s = p(() => e.messages.reduce((e, t, n) => {
			let r = d(t);
			if (n === 0) return [{
				message: t,
				displaySender: !0,
				startAnimation: 0,
				animationDuration: r
			}];
			let { message: a, startAnimation: o, animationDuration: s } = e.at(-1), c = t.direction !== a.direction || t.userName !== a.userName, l = o + s + i;
			return [...e, {
				message: t,
				displaySender: c,
				startAnimation: l,
				animationDuration: r
			}];
		}, [])), u = o("messages");
		function d(t) {
			let n = (t.content?.length ?? 0) * e.animationSpeed;
			return t.image && (n += a), n;
		}
		function f() {
			u.value.forEach((e) => e.reset());
		}
		return t({ reset: f }), (t, a) => (n(), v("figure", A, [l("figcaption", j, m(e.conversationTitle), 1), (n(!0), v(h, null, r(s.value, ({ message: e, displaySender: t, startAnimation: r, animationDuration: a }, o) => (n(), c(k, {
			ref_for: !0,
			ref: "messages",
			key: o,
			message: e,
			"start-animation": r,
			"animation-duration": a,
			"loading-duration": i,
			"display-sender": t
		}, null, 8, [
			"message",
			"start-animation",
			"animation-duration",
			"display-sender"
		]))), 128))]));
	}
}), [["styles", ["figure{background-color:#fff;border-radius:16px;flex-direction:column;gap:8px;margin:0;padding:16px;display:flex}.sr-only{clip-path:inset(50%);white-space:nowrap;border:0;width:1px;height:1px;padding:0;position:absolute;overflow:hidden}"]]]));
M.prototype.normalizeProps = (e) => ({
	...e,
	animationSpeed: S(e.animationSpeed),
	messages: e.messages.map(({ type: e, content: t, image: n, ...r }) => ({
		...r,
		content: x(t),
		image: b(n)
	}))
}), window.customElements.define("message-conversation", M);
//#endregion
